import useReplacedText from '@v4/hooks/useReplacedText'

export const useLinkButton = ({ className, children, href, onClick, editable, onChange, action, ...rest }) => {
	const link = useReplacedText(href)

	return [
		{
			className,
			children,
			href: link || '/',
			editable,
			rest,
			targetProps: link?.startsWith('#') ? {} : { target: '_blank', rel: 'noopener noreferrer' },
		},
		{
			handleClick: onClick,
			handleChange: onChange,
		},
	]
}
